<!--
 * @Name: subMenuItem
 * @Description: 菜单
 * @Author: xiadongxue
 * @Date: 2021-10-22 14:12:52
 * @Editors: xiadongxue
-->
<template>
<div>
    <template v-if="!data.children || (data.children && !data.children.length)">
        <el-menu-item
            :class="{'is-active': $route.path == data.url,'not-active': $route.path !== data.url}"
            :route="data.url"
            :index="JSON.stringify(data)">{{data.menuName}}</el-menu-item>
    </template>
    <template v-else>
        <el-submenu :index="String(data.menuId)">
            <template slot="title">{{ data.menuName }}</template>
            <template v-for="item in data.children">
                <el-menu-item
                    :class="{'is-active': $route.path == item.url,'not-active': $route.path !== item.url}"
                    v-if="!item.children || (item.children && !item.children.length)"
                    :key="item.menuId"
                    :route="item.url"
                    :index="JSON.stringify(item)">{{item.menuName}}</el-menu-item>
                <sub-menu-item
                    v-else
                    :data="item"
                    :key="item.menuId"></sub-menu-item>
            </template>
        </el-submenu>
    </template>
</div>
</template>

<script>
export default {
    name: 'subMenuItem',
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    }

}
</script>
